import { render, staticRenderFns } from "./CPNavigation.vue?vue&type=template&id=86c71532&scoped=true&"
import script from "./CPNavigation.vue?vue&type=script&lang=ts&"
export * from "./CPNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CPNavigation.vue?vue&type=style&index=0&id=86c71532&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c71532",
  null
  
)

export default component.exports